import { render, staticRenderFns } from "./PreviewModal.vue?vue&type=template&id=7064fe20&scoped=true&"
import script from "./PreviewModal.vue?vue&type=script&lang=js&"
export * from "./PreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PreviewModal.vue?vue&type=style&index=1&id=7064fe20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064fe20",
  null
  
)

export default component.exports